import { api } from "../api";

/**
 * ticketGravitiesFindAllByActivated - Function that finds on database all tickets gravities
 * /tickets/gravities/{status} 
 * method GET 
 * @async-function
 */
const ticketGravitiesFindAllByActivated = async (token: string, status: string) => {
    const response = await api.get(
        `/tickets/gravities/${status}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default ticketGravitiesFindAllByActivated;